import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c995d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 运行模拟 ")
const _hoisted_3 = {
  key: 0,
  class: "simulation-result"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("稀有度分布")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("能量值分布")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    title: `盈亏模拟 - ${_ctx.cardPool?.name || ''}`,
    width: "750px",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.cardPool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_form, {
              inline: true,
              class: "mb-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "模拟次数" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.simulationCount,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.simulationCount) = $event)),
                      min: 1000,
                      max: 100000,
                      step: 1000
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.runSimulation,
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "模拟次数",
                            value: _ctx.result.simulation_count
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "单价",
                            value: _ctx.priceYuan,
                            suffix: "元"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "平均回收",
                            value: _ctx.avgRewardYuan,
                            suffix: "元"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "预期利润",
                            value: _ctx.expectedProfitYuan,
                            suffix: "元",
                            "value-style": { color: _ctx.result.expected_profit >= 0 ? '#67C23A' : '#F56C6C' }
                          }, null, 8, ["value", "value-style"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "利润率",
                            value: _ctx.result.profit_rate,
                            suffix: "%",
                            precision: 2,
                            "value-style": { color: _ctx.result.profit_rate >= 0 ? '#67C23A' : '#F56C6C' }
                          }, null, 8, ["value", "value-style"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "保底触发率",
                            value: _ctx.result.guaranteed_trigger_rate,
                            suffix: "%",
                            precision: 2
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "总抽卡数",
                            value: _ctx.result.total_cards_drawn
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_statistic, {
                            title: "每包卡数",
                            value: _ctx.result.cards_per_pack
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_table, {
                    data: _ctx.result.rarity_distribution,
                    "row-config": { isHover: true },
                    "max-height": "250"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vxe_column, {
                        title: "稀有度",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_tag, {
                            type: _ctx.getRarityTagType(row.rarity),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.rarity), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "次数",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.count), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "概率",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.percentage.toFixed(2)) + "% ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "平均回收价",
                        width: "120"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(" ¥" + _toDisplayString(row.avg_recycle_price.toFixed(2)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "概率条",
                        "min-width": "180"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_progress, {
                            percentage: Math.min(row.percentage, 100),
                            color: _ctx.getProgressColor(row.percentage),
                            "show-text": false
                          }, null, 8, ["percentage", "color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_vxe_table, {
                    data: _ctx.result.energy_distribution,
                    "row-config": { isHover: true },
                    "max-height": "250"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vxe_column, {
                        title: "能量值",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_tag, {
                            type: row.energy === 0 ? 'success' : 'info',
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.energy), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "次数",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.count), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "概率",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.percentage.toFixed(2)) + "% ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_vxe_column, {
                        title: "概率条",
                        "min-width": "200"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_progress, {
                            percentage: Math.min(row.percentage, 100),
                            color: _ctx.getProgressColor(row.percentage),
                            "show-text": false
                          }, null, 8, ["percentage", "color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "点击「运行模拟」开始模拟"
                }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}